import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

// Importando os subcomponentes de Análises
import AnaliseMagicoCoringa from './Analise/AnaliseMagicoCoringa';
import AnaliseMult3PerfCM from './Analise/AnaliseMult3PerfCM';
import AnaliseFibonacciCM from './Analise/AnaliseFibonacciCM';
import AnalisePrimoCM from './Analise/AnalisePrimoCM';
import AnaliseLinhas from './Analise/AnaliseLinhas';
import AnaliseColunas from './Analise/AnaliseColunas';
import AnaliseLinhasImpar from './Analise/AnaliseLinhasImpar';
import AnaliseLinhasPares from './Analise/AnaliseLinhasPares';
import AnaliseMultiplo3 from './Analise/AnaliseMultiplo3';
import AnaliseFibonacci from './Analise/AnaliseFibonacci';
import AnalisePrimos from './Analise/AnalisePrimos';
import AnaliseTriangular from './Analise/AnaliseTriangular';
import AnalisePerfeito from './Analise/AnalisePerfeito';
import AnaliseRepetidos from './Analise/AnaliseRepetidos';
import AnaliseSequencia from './Analise/AnaliseSequencia';
import AnaliseAsteriscos from './Analise/AnaliseAsteriscos';
import AnaliseInicio from './Analise/AnaliseInicio';
import AnaliseFinal from './Analise/AnaliseFinal';
import AnaliseMagico from './Analise/AnaliseMagico';
import AnaliseSoma from './Analise/AnaliseSoma';
import AnaliseCoringa from './Analise/AnaliseCoringa';
import AnaliseMisticos from './Analise/AnaliseMisticos';
import AnaliseMolduras from './Analise/AnaliseMolduras';
import AnaliseParImpar from './Analise/AnaliseParImpar';
import AnaliseSomaCC from './Analise/AnaliseSomaCC';
import AnalisePrimoCmCC from './Analise/AnalisePrimoCmCC';
import AnaliseFiboCmCC from './Analise/AnaliseFiboCmCC';
import AnaliseMix3xPerfCC from './Analise/AnaliseMix3xPerfCC';
import AnaliseMagicoCoringaCC from './Analise/AnaliseMagicoCoringaCC';
import AnaliseAsteriscosCC from './Analise/AnaliseAsteriscosCC';
import AnaliseTriangularesCC from './Analise/AnaliseTriangularesCC';
import AnalisePerfeitoCC from './Analise/AnalisePerfeitoCC';
import AnaliseCoringaCC from './Analise/AnaliseCoringaCC';
import AnaliseFibonacciCC from './Analise/AnaliseFibonacciCC';
import AnaliseMultiplo3CC from './Analise/AnaliseMultiplo3CC';
import AnalisePrimosCC from './Analise/AnalisePrimosCC';
import AnaliseMagicosCC from './Analise/AnaliseMagicosCC';
import AnaliseParImparCC from './Analise/AnaliseParImparCC';
import AnaliseMoldurasCC from './Analise/AnaliseMoldurasCC';

const Page = () => {
  const { title } = useParams(); // Captura o parâmetro 'title' da URL
  const [content, setContent] = useState(null);

  useEffect(() => {
    const fetchContent = () => {
      // Lógica para definir o conteúdo com base no título
      switch (title) {
        case 'analise_magico_coringa':
          setContent(<AnaliseMagicoCoringa />);
          break;
        
        case 'analise_mult3_perf_cm':
          setContent(<AnaliseMult3PerfCM />);
          break;

        case 'analise_fibonacci_cm':
          setContent(<AnaliseFibonacciCM />);
          break;

        case 'analise_primo_cm':
          setContent(<AnalisePrimoCM />);
          break;

        case 'analise_linhas':
          setContent(<AnaliseLinhas />);
          break;

        case 'analise_colunas':
          setContent(<AnaliseColunas />);
          break;
        
        case 'analise_linhas_impar':
          setContent(<AnaliseLinhasImpar />);
          break;
            
        case 'analise_linhas_pares':
          setContent(<AnaliseLinhasPares />);
          break;

        case 'analise_multiplo3':
          setContent(<AnaliseMultiplo3 />);
          break;

        case 'analise_fibonacci':
          setContent(<AnaliseFibonacci />);
          break;

        case 'analise_primos':
          setContent(<AnalisePrimos />);
          break;

        case 'analise_triangular':
          setContent(<AnaliseTriangular />);
          break;

        case 'analise_perfeito':
          setContent(<AnalisePerfeito />);
          break;

        case 'analise_repetidos':
          setContent(<AnaliseRepetidos />);
          break;

        case 'analise_sequencia':
          setContent(<AnaliseSequencia />);
          break;

        case 'analise_asteriscos':
          setContent(<AnaliseAsteriscos />);
          break;

        case 'analise_inicio':
          setContent(<AnaliseInicio />);
          break;

        case 'analise_final':
          setContent(<AnaliseFinal />);
          break;

        case 'analise_magico':
          setContent(<AnaliseMagico />);
          break;

        case 'analise_soma':
          setContent(<AnaliseSoma />);
          break;

        case 'analise_coringa':
          setContent(<AnaliseCoringa />);
          break;

        case 'analise_misticos':
          setContent(<AnaliseMisticos />);
          break;

        case 'analise_molduras':
          setContent(<AnaliseMolduras />);
          break;

        case 'analise_par_impar':
          setContent(<AnaliseParImpar />);
          break;
        
        case 'analise_magicoCoringa_CC':
          setContent(<AnaliseMagicoCoringaCC />);
          break;

        case 'analise_mix3xPerf_CC':
          setContent(<AnaliseMix3xPerfCC />);
          break;

        case 'analise_fiboCm_CC':
          setContent(<AnaliseFiboCmCC />);
          break;
        
        case 'analise_prioCm_CC':
          setContent(<AnalisePrimoCmCC />);
          break;
        
        case 'analise_soma_CC':
          setContent(<AnaliseSomaCC />);
          break;
        
        case 'analise_asteriscos_CC':
          setContent(<AnaliseAsteriscosCC />);
          break;

        case 'analise_triangulares_CC':
          setContent(<AnaliseTriangularesCC />);
          break;
        
        case 'analise_numerosPerfeitos_CC':
          setContent(<AnalisePerfeitoCC />);
          break;
        
        case 'analise_coringa_CC':
          setContent(<AnaliseCoringaCC />);
          break;
        
        case 'analise_fibonacci_cc':
          setContent(<AnaliseFibonacciCC />);
          break;
        
        case 'analise_multiplo3_CC':
          setContent(<AnaliseMultiplo3CC />);
          break;
        
        case 'analise_primos_CC':
          setContent(<AnalisePrimosCC />);
          break;  
        
        case 'analise_magicos_CC':
          setContent(<AnaliseMagicosCC />);
          break;
        
        case 'analise_par_impar_CC':
          setContent(<AnaliseParImparCC />);
          break;
        
        case 'analise_molduras_CC':
          setContent(<AnaliseMoldurasCC />);
          break;
        
        // Caso não encontrado
        default:
          Swal.fire({
            title: 'Ops!',
            text: `Conteúdo não encontrado para: ${title}`,
            icon: 'warning',
            confirmButtonText: 'Voltar'
          }).then(() => {
            // Redireciona para a página anterior
            window.history.back();
          });
          setContent(null); // não renderiza nada, apenas mostra o alerta
          break;
      }
    };

    fetchContent();
  }, [title]);

  return (
    <div>
      {content}
    </div>
  );
};

export default Page;
